module.exports = __webpack_public_path__ + "img/cloud_left.9e5af2e1.png";